import { SampleView } from '../enums/sample-view.enum';

export class GuidedOrderState {
  constructor(
    sampleView?: SampleView
  ) { }

  sampleView?: SampleView;
}
